import { render, staticRenderFns } from "./settle-result.vue?vue&type=template&id=65a6b3fe&scoped=true"
import script from "./settle-result.vue?vue&type=script&lang=js"
export * from "./settle-result.vue?vue&type=script&lang=js"
import style0 from "./settle-result.vue?vue&type=style&index=0&id=65a6b3fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a6b3fe",
  null
  
)

export default component.exports